import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PublicRoutes from './PublicRoutes';
import PrivateRoutes from './PrivateRoutes';
import SharedContentViewer from '../pages/Shared/SharedContentViewer';
import { ContactUs } from '../pages';

interface AppRoutesProps {
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
  onLogout: () => void;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ isAuthenticated, setIsAuthenticated, onLogout }) => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Shared routes - accessible to everyone with same design */}
        <Route path="/shared/:shareId" element={<SharedContentViewer />} />
        <Route path="/contact-us" element={<ContactUs />} />

        {/* All other routes based on authentication */}
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <PrivateRoutes onLogout={onLogout} />
            ) : (
              <PublicRoutes setIsAuthenticated={setIsAuthenticated} />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
